/* eslint-disable eqeqeq */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import * as React from "react";
import { useHistory } from 'react-router-dom';

import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import WidgetsIcon from "@mui/icons-material/Widgets";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer({displayDrawer,openClose, details }) {
  const history = useHistory();

  const myStyles={ 
      margin: "0.1em",
      marginLeft: "0.2em",
      fontSize: "11px !important",
      fontWeight: "bold",
      textAlign: "left",
      letterSpacing: "0em",
      color: "#4e4e4e",
      opacity: 1
    
  }
  const theme = useTheme();
  const [open, setOpen] = React.useState(openClose);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  React.useEffect(() => {
  }, []);
  const handleDrawerClose = () => {
    setOpen(false);
  };
  var displayFlag=openClose?"block":"none"


  return (
    <div>
      { displayDrawer=="mobile"?
      <Drawer
        variant="permanent"
        open={openClose}
     
        PaperProps={{
          sx: {
            height: "90%",
            width: "40%",
            top: 52,
            marginBottom: "40px",
          },
        }}

        style={{display:displayFlag}}

      >
    
        <List>
          {["Home"].map((text, index) => (
            <ListItem  disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 20,
                  justifyContent: open ? "initial" : "center",
                  px: 1.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 20,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <WidgetsIcon style={{color: "#2162ac"}} />
                </ListItemIcon>
                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} style={myStyles}/>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
      </Drawer>:
            <Drawer
            variant="permanent"
            open={open}
            onMouseEnter={handleDrawerOpen}
            onMouseLeave={handleDrawerClose}
            PaperProps={{
              sx: {
                height: "90%",
                top: 52,
                marginBottom: "35px",
              },
            }}
    
          >
            {/* <DrawerHeader>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </DrawerHeader>
            <Divider /> */}
            <List>
            
                <ListItem  disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                  <WidgetsIcon style={{color: "#2162ac"}} />
                    </ListItemIcon>
                    <ListItemText primary="Home" sx={{ opacity: open ? 1 : 0 }} />
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem  disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                  <CalendarMonthIcon style={{color: "#2162ac"}}  onClick={()=>{history.push('/erc-batch-time-booking')}}/>
                    </ListItemIcon>
                    <ListItemText primary="Batch Booking" sx={{ opacity: open ? 1 : 0 }} />
                  </ListItemButton>
                </ListItem>
            
            </List>
            <Divider />
          </Drawer>
}
      <Box component="main">
        {/* <DrawerHeader /> */}
        {details}
      </Box>
    </div>
  );
}
